import { WordpressImage } from "ts/types";

import {
  SkeletonBadges,
  SkeletonCards,
  StyledCardRow,
  StyledRow,
  StyledWrapper,
} from "./Cards.Styled";
import { FunctionComponent } from "react";

/**
 * Cleans unwanted HTML tags from the description and extracts a clean URL if available.
 * - Removes <p> tags
 * - Removes leading/trailing spaces
 * - If WordPress oEmbed returns <blockquote><a href="...">...</a></blockquote>,
 *   it extracts the real href link
 *
 * @param {string} description - The HTML string (possibly with tags).
 * @returns {string} - A cleaned string or extracted URL.
 */
const cleanDescription = (description?: string) => {
  if (!description) return "";

  let cleaned = description.replace(/<\/?p>/g, "").trim();

  const match = cleaned.match(/href="([^"]+)"/);
  if (match) {
    return match[1]; 
  }

  return cleaned;
};

interface CardsProps {
  loading?: boolean;
  badges: WordpressImage[];
  paymentMethodIcons: WordpressImage[];
}

const Cards: FunctionComponent<CardsProps> = ({
  loading = false,
  badges,
  paymentMethodIcons,
}) => {
  if (loading) {
    return (
      <StyledWrapper>
        <StyledRow>
          <SkeletonBadges />
        </StyledRow>
        <StyledCardRow>
          <SkeletonCards />
        </StyledCardRow>
      </StyledWrapper>
    );
  }

  return (
    <StyledWrapper>
      
      <StyledRow>
        {badges.map((badge) => {
          return (
            <a 
              key={badge.id}
              href={cleanDescription(badge.description)}
              target="_blank"
              rel="noopener noreferrer">
            <img
              key={badge.id}
              title={badge.title}
              alt={badge.altText}
              src={badge.sourceUrl}
            />
            </a>
          );
        })}
      </StyledRow>
      <StyledCardRow>
        {paymentMethodIcons.map((icon) => {
          return (
            <a 
              key={icon.id}
              href={cleanDescription(icon.description)}
              target="_blank"
              rel="noopener noreferrer">
            <img
              key={icon.id}
              title={icon.title}
              alt={icon.altText}
              src={icon.sourceUrl}
            />
            </a>
          );
        })}
      </StyledCardRow>
    </StyledWrapper>
  );
};

export default Cards;
